import { TextField, type TextFieldProps } from '@sapphire-react/core';
import { useEffect } from 'react';
import { useIMask } from 'react-imask';
import styled from 'styled-components';
import { THOUSAND_SEPARATOR } from '../constants/common';
import { useSapphireMedia } from '../hooks';

export function MaskedNumberField(
  props: TextFieldProps & {
    min?: number;
    max?: number;
  },
) {
  const { inputMode, name, min, max, value, label, onChange, type, ...rest } =
    props;
  const { isExtraSmall, isSmall } = useSapphireMedia();
  const { ref, unmaskedValue } = useIMask<any>(
    {
      mask: Number, // enable number mask
      scale: inputMode === 'decimal' ? 2 : 0, // digits after point, 0 for integers
      thousandsSeparator: THOUSAND_SEPARATOR, // any single char
      padFractionalZeros: false, // if true, then pads zeros at end to the length of scale
      radix: ',', // fractional delimit
      min,
      max,
    },
    { defaultUnmaskedValue: value?.toString() },
  );

  useEffect(() => {
    onChange?.(unmaskedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unmaskedValue]);

  return (
    <Wrapper>
      <TextField
        name={name}
        size={isExtraSmall || isSmall ? 'md' : 'lg'}
        inputRef={ref}
        label={label}
        type={type}
        inputMode={inputMode || 'numeric'}
        alignInputRight
        data-test-id={`${name}-AmountInput`}
        onInput={() => {
          if (type !== 'number') onChange?.(unmaskedValue);
        }}
        {...rest}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  input:focus {
    border: none;
    background: unset;
    outline: none;
  }
  label {
    display: inline;
  }

  // Fixes scroll issue in sitecore
  input {
    height: 100%;
    width: 100%;
  }
`;
